
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type dialogButtonMobileRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function dialogButtonMobileRT(): TemplateResult<dialogButtonMobileRTRootProps> {
    return _createElement('div', { 'className': 'cm_search-box-root__dialog_open-button' }, [this.searchBoxDialogButton(function () {
            return _createElement('div', { 'className': 'cm_desktop-hide  cm_searchBoxDialogButton' }, _createElement('svg', { 'className': 'icon-search' }, _createElement('use', { 'href': '#icon-cavio_search' })));
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:searchBoxDialogButton"]